import { render } from "./index-details.vue?vue&type=template&id=abff65ac&scoped=true&lang=true"
import script from "./index-details.vue?vue&type=script&lang=js"
export * from "./index-details.vue?vue&type=script&lang=js"

import "./index-details.scss?vue&type=style&index=0&id=abff65ac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abff65ac"

export default script